import React, { useEffect, useState } from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { PlatformSection } from './components/PlatformSection';
import { TimelineSection } from './components/TimelineSection';
import { TechnologySection } from './components/TechnologySection';
import { AboutSection } from './components/AboutSection';
import { TeamSection } from './components/TeamSection';
import { CareersPage } from './components/CareersPage';
export function App() {
  const [currentPage, setCurrentPage] = useState(window.location.pathname === '/careers' ? 'careers' : 'home');
  useEffect(() => {
    const handleNavigation = () => {
      setCurrentPage(window.location.pathname === '/careers' ? 'careers' : 'home');
    };
    window.addEventListener('popstate', handleNavigation);
    // Handle link clicks
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const link = target.closest('a');
      if (link && link.href.includes('/careers')) {
        e.preventDefault();
        window.history.pushState({}, '', '/careers');
        setCurrentPage('careers');
        window.scrollTo(0, 0);
      } else if (link && link.getAttribute('href') === '/') {
        e.preventDefault();
        window.history.pushState({}, '', '/');
        setCurrentPage('home');
        window.scrollTo(0, 0);
      }
    };
    document.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('popstate', handleNavigation);
      document.removeEventListener('click', handleClick);
    };
  }, []);
  if (currentPage === 'careers') {
    return <div className="min-h-screen bg-[#1a1a1a] selection:bg-[#1e3a5f] selection:text-white" data-id="element-0">
        <Navigation data-id="element-1" />
        <CareersPage data-id="element-2" />
        <footer className="bg-[#1a1a1a] text-gray-500 py-12 px-4 border-t border-white/10" data-id="element-3">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center" data-id="element-4">
            <p className="text-sm" data-id="element-5">
              © {new Date().getFullYear()} Pimlico Trading. All rights
              reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-6">
              <a href="#" className="text-sm hover:text-white transition-colors" data-id="element-7">
                Privacy Policy
              </a>
              <a href="#" className="text-sm hover:text-white transition-colors" data-id="element-8">
                Terms of Service
              </a>
            </div>
          </div>
        </footer>
      </div>;
  }
  return <div className="min-h-screen bg-[#fafafa] selection:bg-[#1e3a5f] selection:text-white" data-id="element-9">
      <Navigation data-id="element-10" />
      <main data-id="element-11">
        <Hero data-id="element-12" />
        <PlatformSection data-id="element-13" />
        <TimelineSection data-id="element-14" />
        <TechnologySection data-id="element-15" />
        <AboutSection data-id="element-16" />
        <TeamSection data-id="element-17" />
      </main>

      <footer className="bg-[#1a1a1a] text-gray-500 py-12 px-4 border-t border-white/10" data-id="element-18">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center" data-id="element-19">
          <p className="text-sm" data-id="element-20">
            © {new Date().getFullYear()} Pimlico Trading. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-21">
            <a href="#" className="text-sm hover:text-white transition-colors" data-id="element-22">
              Privacy Policy
            </a>
            <a href="#" className="text-sm hover:text-white transition-colors" data-id="element-23">
              Terms of Service
            </a>
          </div>
        </div>
      </footer>
    </div>;
}